import { objectId } from "@redotech/rpc/ext";
import * as z from "zod";

export const recordRescuePanelTriggered = {
  name: "recordRescuePanelTriggered" as const,
  input: z.object({ treatmentId: objectId() }),
  output: z.void(),
};
